import { useEffect, useState } from 'react';

import STORE from 'store';
import useCurrentAccountId from 'hooks/useCurrentAccountId';

const RECENT_RUNS_LIMIT = 10;

const useReportScheduleRuns = ({ scheduleId }: { scheduleId: string }) => {
  const accountId = useCurrentAccountId();
  const [runs, setRuns] = useState<ReportSchedules.Run[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isActive = true;

    const unsubscribe = STORE.contentDistributions
      .getReportScheduleRunsRef({ accountId, scheduleId })
      .orderBy('slot', 'desc')
      .limit(RECENT_RUNS_LIMIT)
      .onSnapshot(
        (snapshot) => {
          if (!isActive) return;
          setRuns(snapshot.docs.map((d) => d.data()));
          setIsLoading(false);
        },
        () => {
          // Surface failures (e.g. permission denied) instead of hanging in a
          // perpetual loading state, which hides the "No runs yet" fallback.
          if (!isActive) return;
          setIsLoading(false);
        },
      );

    return () => {
      isActive = false;
      unsubscribe();
    };
  }, [accountId, scheduleId]);

  return { runs, isLoading };
};

export default useReportScheduleRuns;
